module.exports = __webpack_public_path__ + "static/media/profile.6d0cabaf.svg";